export const comments_5618941 = {"data":{"data":[],"links":{}}}